export interface IBillRecordItem {
  id?: number;
  name?: string;
  amount?: number;
  position?: number;
  billRecordId?: number;
}

export const defaultValue: Readonly<IBillRecordItem> = {};
